<style>
    .card .card-content .card-title {
        margin: 20px 0 20px 0 !important;
    }

    .text-center-important {
        text-align: center
    }

    .main-number {
        font-weight: bold
    }

    .right {
        float: right;
        font-size: 12px
    }
</style>
<div class="main-content" *ngIf="!admins">
    <div class="loader"></div>
</div>
<div *ngIf="admins != null">
    <div class="col-md-12">
        <div class="card">
            <div class="card-content">
                <div class="row">
                    <div class="col-md-3">
                        <h4 class="card-title" style="float: right;margin: 5px 0 20px 0 !important;">Filtrar:</h4>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <select class="form-control" name="month" [(ngModel)]="month">
                                <option [value]="0">Mês Atual</option>
                                <option [value]="1">Janeiro</option>
                                <option [value]="2">Fevereiro</option>
                                <option [value]="3">Março</option>
                                <option [value]="4">Abril</option>
                                <option [value]="5">Maio</option>
                                <option [value]="6">Junho</option>
                                <option [value]="7">Julho</option>
                                <option [value]="8">Agosto</option>
                                <option [value]="9">Setembro</option>
                                <option [value]="10">Outubro</option>
                                <option [value]="11">Novembro</option>
                                <option [value]="12">Dezembro</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <select class="form-control" name="year" [(ngModel)]="year">
                                <option [value]="0">Ano Atual</option>
                                <option [value]="2017">2017</option>
                                <option [value]="2018">2018</option>
                                <option [value]="2019">2019</option>
                                <option [value]="2020">2020</option>
                                <option [value]="2021">2021</option>
                                <option [value]="2022">2022</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <button type="button" (click)="filterPeriod()"
                            class="btn btn-wd btn-default btn-fill btn-move-right">Filtrar
                            <span class="btn-label">
                                <i class="ti-angle-right"></i>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div class="row">
            <div class="col-lg-12 col-xl-12">
                <div class="card">
                    <div class="card-content">
                        <div class="row">
                            <div class="col-lg-3 col-xl-6">
                                <span class="ti-info-alt right" [tooltip]="SalesWithDonation"></span>
                                <div class="numbers text-center-important">
                                    <p>Receita via Polen</p>
                                    <span class="main-number">R$ {{totalRevenue | number: '.2-2'}}</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-xl-6">
                                <span class="ti-info-alt right" [tooltip]="SalesWithDonation"></span>
                                <div class="numbers text-center-important">
                                    <p>Total Doado</p>
                                    <span class="main-number">R$ {{totalDonation | number: '.2-2'}}</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-xl-6">
                                <span class="ti-info-alt right" [tooltip]="SalesWithDonation"></span>
                                <div class="numbers text-center-important">
                                    <p>Melhoria de Conversão</p>
                                    <span class="main-number">{{avgConversionImprove | number: '.2-2'}}%</span>
                                </div>
                            </div>
                            <div class="col-lg-3 col-xl-6">
                                <span class="ti-info-alt right" [tooltip]="SalesWithDonation"></span>
                                <div class="numbers text-center-important">
                                    <p>Melhoria Ticket Médio</p>
                                    <span class="main-number">{{avgTicketImproved | number: '.2-2'}}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-group" id="accordion" style="display: none;">
        <div *ngFor="let chart of admins; let i = index" [attr.data-index]="i" class="panel panel-border panel-default">
            <a data-toggle="collapse" href="#collapse{{i}}">
                <div class="panel-heading">
                    <h4 class="panel-title">
                        {{ chart.storeName}}
                        <i class="ti-angle-down"></i>
                    </h4>
                </div>
            </a>
            <div id="collapse{{i}}" class="panel-collapse collapse">
                <div class="panel-body">
                    <!-- <div class="main-content" *ngIf="!chart">
                        <div class="loader"></div>
                    </div> -->
                    <div class="main-content" *ngIf="chart">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-4">
                                    <h2 style="margin:0">{{ chart.storeName}}</h2>
                                </div>
                            </div>
                            <div class="row" style="margin-top: 25px;">
                                <div class="col-md-8">
                                    <div class="row">
                                        <div class="col-lg-6 col-xl-6">
                                            <div class="card">
                                                <div class="card-content">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <tooltip-content #saleConversion>
                                                                <b>Conversão de Venda com Polen</b>
                                                                <br>
                                                                <br>
                                                                <span>É o percentual de compras feitas na sua loja a
                                                                    partir do
                                                                    total
                                                                    de visitantes únicos no período.</span>
                                                                <br>
                                                                <br>
                                                                <span>Ex.: Em 30 dias sua loja teve 1000 visitas e 15
                                                                    vendas.
                                                                    Nesse
                                                                    caso,
                                                                    a conversão de venda de sua loja foi de 1.5%</span>
                                                            </tooltip-content>
                                                            <span class="ti-info-alt right"
                                                                [tooltip]="saleConversion"></span>
                                                            <div class="numbers text-center-important">
                                                                <p>Conversão de Venda com Polen</p>
                                                                <span
                                                                    class="main-number">{{chart.conversionSalesWithPolen
                                                                    |
                                                                    number:'.2-2'}}%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <hr>
                                                    <div class="stats text-center">
                                                        <span class="ti-arrow-up icon-success"></span>
                                                        {{chart.conversionSalesImprovement
                                                        | number:'.2-2'}}% maior que o da loja sem o Polen
                                                        <br> ( {{chart.conversionSalesWithoutPolen | number:'.2-2'}}%)
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xl-6">
                                            <div class="card">
                                                <div class="card-content">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <tooltip-content #chooseVsSale>
                                                                <b>Escolheu Ong e Finalizou Compra</b>
                                                                <br>
                                                                <br>
                                                                <span>Esse número representa a quantidade de
                                                                    consumidores que
                                                                    escolheram
                                                                    uma Ong e finalizaram a compra.</span>
                                                                <br>
                                                                <br>
                                                                <span>Ex.: Das 100 pessoas que escolheram uma Ong para
                                                                    apoiar,
                                                                    30
                                                                    compraram.
                                                                    Logo, 30% escolheu Ong e finalizou a compra.</span>
                                                            </tooltip-content>
                                                            <span class="ti-info-alt right"
                                                                [tooltip]="chooseVsSale"></span>
                                                            <div class="numbers text-center-important">
                                                                <p>Escolheu Ong e Finalizou Compra</p>
                                                                <span class="main-number">{{
                                                                    chart.conversionChooseDonateToPurchase
                                                                    |
                                                                    number:'.2-2'}}%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <hr>
                                                    <div class="stats text-center">
                                                        das {{chart.totalChooseToDonate}} pessoas que escolheram uma
                                                        Ong,
                                                        {{chart.purchasesWithDonation}} finalizaram a compra. vendas)
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6 col-xl-3">
                                            <div class="card">
                                                <div class="card-content">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <tooltip-content #SalesWithDonation>
                                                                <b>Vendas com doação</b>
                                                                <br>
                                                                <br>
                                                                <span>A Receita total das vendas que tiveram
                                                                    doação.</span>
                                                                <br>
                                                                <br>
                                                                <span>Importante lembrar que é um valor prévio a partir
                                                                    de
                                                                    vendas
                                                                    confirmadas,
                                                                    independente se foram pagas ou não.</span>
                                                            </tooltip-content>
                                                            <span class="ti-info-alt right"
                                                                [tooltip]="SalesWithDonation"></span>
                                                            <div class="numbers text-center-important">
                                                                <p>Vendas com doação</p>
                                                                <span class="main-number">R$
                                                                    {{chart.revenueWithDonation |
                                                                    number:
                                                                    '.2-2'}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <hr>
                                                    <div class="stats text-center">
                                                        de R${{chart.revenueTotal | number: '.2-2'}} ({{
                                                        chart.conversionRevenueToRevenueWithDonation |
                                                        number:'1.2-2'}}% do
                                                        total)
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xl-3">
                                            <div class="card">
                                                <div class="card-content">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <tooltip-content #Donations>
                                                                <b>Total Doado no período</b>
                                                                <br>
                                                                <br>
                                                                <span>Total das doações realizadas a partir das
                                                                    vendas.</span>
                                                                <br>
                                                                <br>
                                                                <span>Importante lembrar que é um valor prévio a partir
                                                                    de
                                                                    vendas
                                                                    confirmadas,
                                                                    independente se foram pagas ou não.</span>
                                                            </tooltip-content>
                                                            <span class="ti-info-alt right"
                                                                [tooltip]="Donations"></span>
                                                            <div class="numbers text-center-important">
                                                                <p>Doações</p>
                                                                <span class="main-number">R$ {{chart.totalDonated |
                                                                    number:
                                                                    '2.2-2'}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <hr>
                                                    <div class="stats text-center">
                                                        A partir de {{ chart.purchasesWithDonation }} vendas
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="card">
                                        <div class="card-content">
                                            <div id="chartContainer"
                                                style="height: 370px; width: 100%; margin-left:auto;margin-right:auto;">
                                            </div>
                                            <div class="tapa"
                                                style="width: 100%;height: 10px;background: white;position: relative;bottom: 11px;">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-lg-12 col-xl-12">
                                    <div class="card">
                                        <div class="card-content">
                                            <div class="row">
                                                <div class="col-md-5 col-xs-5">
                                                    <div class="card-content">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="numbers" style="text-align: center">
                                                                    {{chart.conversionVisitToChooseDonate | number:
                                                                    '.2-2'}}%
                                                                    do
                                                                    seu tráfego
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-footer" style="text-align: center;">
                                                        <hr> Do total de {{ chart.views | number }} visitas, {{
                                                        chart.totalChooseToDonate
                                                        }} consumidores escolheram uma Ong.
                                                    </div>
                                                </div>
                                                <div class="col-md-1 col-xs-1">
                                                    <div class="icon-big icon-success text-center"
                                                        style="margin-top: 49px;">
                                                        <i class="ti-arrow-right"></i>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-xs-6">
                                                    <div class="card-content">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="numbers" style="text-align: center">
                                                                    realizou
                                                                    {{chart.conversionPurchaseToPurchaseWithDonation |
                                                                    number: '.2-2'}}% das suas vendas
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-footer" style="text-align: center;">
                                                        <hr> Do total de {{ chart.purchasesTotal }} vendas, {{
                                                        chart.purchasesWithDonation
                                                        }} vendas foram com doação.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card" *ngIf="chart && chart.visibilityChart">
                                        <cabianca-chart [typeName]="'visibility'" [chart]="chart.visibilityChart">
                                        </cabianca-chart>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card" *ngIf="chart && chart.clicksChart">
                                        <cabianca-chart [typeName]="'engagement'" [chart]="chart.clicksChart">
                                        </cabianca-chart>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="card" *ngIf="chart && chart.clicksChartV2">
                                        <cabianca-chart [typeName]="'clickv2'" [chart]="chart.clicksChartV2">
                                        </cabianca-chart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>